module.exports = __webpack_public_path__ + "static/media/bg-birthday.35c4af7f.png";


//////////////////
// WEBPACK FOOTER
// ./src/modules/birthday/components/images/bg-birthday.png
// module id = 988
// module chunks = 0